import { useTranslate } from '@tolgee/react';
import { Menu } from 'antd';
import { DatePicker } from 'components/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { useRef, useState } from 'react';

type Value =
  | {
      type: 'hours';
      hours: number;
    }
  | {
      type: 'custom';
      day: Dayjs;
    };

const unrealDay = dayjs().add(9999, 'years');

function DueTimeEnd({
  disabled,
  value,
  onChange,
}: {
  disabled?: boolean;
  value?: Value;
  onChange?: (value?: Value) => void;
}) {
  const { t } = useTranslate();

  const [open, setOpen] = useState(false);

  const menuClickRef = useRef(false);

  return (
    <DatePicker
      className="w-[160px]"
      showTime
      allowClear
      showNow={false}
      disabled={disabled}
      open={open}
      onOpenChange={(open) => {
        if (open) {
          setOpen(true);
        } else {
          setTimeout(() => {
            if (menuClickRef.current) {
              menuClickRef.current = false;
            } else {
              setOpen(false);
            }
          }, 200);
        }
      }}
      value={value ? (value.type === 'hours' ? unrealDay : value.day) : undefined}
      onChange={(day) =>
        onChange?.(
          day
            ? {
                type: 'custom',
                day,
              }
            : undefined,
        )
      }
      format={() => {
        if (!value) {
          return '';
        }
        if (value?.type === 'hours') {
          return t('近x小时', { x: value.hours });
        }
        return value.day.format('YYYY-MM-DD HH:mm:ss');
      }}
      panelRender={(panel) => {
        const menu = (
          <Menu
            selectedKeys={value?.type === 'hours' ? [`${value.hours}`] : ['0']}
            onClick={({ key }) => {
              menuClickRef.current = true;
              const hours = Number(key);
              if (hours) {
                onChange?.({
                  type: 'hours',
                  hours,
                });
              } else {
                if (value?.type === 'hours') {
                  onChange?.({
                    type: 'custom',
                    day: dayjs().add(value.hours, 'hours'),
                  });
                }
              }
            }}
          >
            {[1, 12, 24].map((hours) => {
              return <Menu.Item key={`${hours}`}>{t('近x小时', { x: hours })}</Menu.Item>;
            })}
            <Menu.Item key={0}>{t('custom')}</Menu.Item>
          </Menu>
        );

        if (value?.type === 'hours') {
          return menu;
        }

        return (
          <div className="flex">
            {menu}
            {panel}
          </div>
        );
      }}
    />
  );
}

export default DueTimeEnd;
